import { apiSlice } from '../api/apiSlice';
import {
  GetCountriesParams,
  GetCountriesResponse,
  GetCountryParams,
  GetCountryResponse,
  GetPopularCountriesParams,
  GetPopularCountriesResponse,
} from './countryApiSliceTypes';

const countryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<GetCountriesResponse, GetCountriesParams>({
      query: (params) => ({
        url: '/countries',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
        params: {
          includeRegion: params.includeRegion ?? false,
        },
      }),
    }),

    getCountry: builder.query<GetCountryResponse, GetCountryParams>({
      query: (params) => ({
        url: `/countries/country/${params.id}`,
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
        params: {
          includeRegion: params.includeRegion ?? false,
        },
      }),
    }),

    getPopularCountries: builder.query<
      GetPopularCountriesResponse,
      GetPopularCountriesParams
    >({
      query: (params) => ({
        url: '/countries/populars',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
        params: {
          limit: params.limit ?? 10,
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCountriesQuery,
  useLazyGetCountriesQuery,
  useGetCountryQuery,
  useLazyGetCountryQuery,
  useGetPopularCountriesQuery,
  useLazyGetPopularCountriesQuery,
} = countryApiSlice;
